import React, { useEffect, useState } from 'react'
import BarcodeGenerator from '@components/Barcode/index'

const OneSeriesBarcodePage = () => {
	const [data, setData] = useState(null)

	useEffect(() => {
		const storedData = localStorage.getItem('seriesData')

		if (storedData) {
			const parsed = JSON.parse(storedData)
			setData(parsed)
			console.log('data =', parsed)
		}

		setTimeout(() => {
			window.print()
		}, 1000)
	}, [])

	if (!data) return null

	return (
		<>
			{/* PRINT CSS */}
			<style>
				{`
          @media print {

            @page {
              size: 80mm 50mm;
              margin: 0;
            }

            html, body {
              width: 80mm;
              height: 50mm;
              margin: 0;
              padding: 0;
            }

            .label {
              width: 80mm;
              height: 50mm;
              padding: 4mm;
              box-sizing: border-box;
              page-break-after: always;
            }

            .label:last-child {
              page-break-after: auto;
            }
          }
        `}
			</style>

			<div className="bg-white text-black font-sans w-[80mm]">
				<div
					key={`${data?.docNum}-${data?.serialNumber}`}
					className="label flex flex-col gap-1"
				>
					<p className="text-sm font-extrabold">{data?.cardName}</p>

					<div className="flex justify-between items-center">
						<p className="text-sm font-extrabold">
							{data?.salesOrderDocNumPrefix}
						</p>

						<div className="flex gap-1">
							<p>Дата:</p>
							<p className="font-extrabold">{data?.dueDate}</p>
						</div>
					</div>

					<p className="text-[14px]">{data?.itemName}</p>

					<div className="flex justify-between items-center">
						<p className="text-sm font-extrabold">
							{data?.width
								? `${data?.width} x ${data?.hight}`
								: ''}
						</p>

						<div className="flex gap-1">
							<p>Деталь:</p>
							<p className="text-lg font-extrabold">
								{data?.serialNumber}
							</p>
						</div>
					</div>

					<BarcodeGenerator
						docNum={data?.serialNumber}
						displayValue={false}
						width={2}
						height={40}
						margin={0}
						fontSize={'10'}
						className="mt-3"
					/>
				</div>
			</div>
		</>
	)
}

export default OneSeriesBarcodePage
